import {add} from "date-fns";
import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "providerapp/pagination";
import {AuthorizationInfo, AuthorizationSortBy, SortOrder} from "../domain";
import {DEFAULT_PAGE_SIZE} from "../../const";

export type  AuthorizationListFilterValue = {
    authType: string;
    serviceType: string;
    status: string;
    reportSubmittedDateFrom: Date | null;
    reportSubmittedDateTo: Date | null;

    reportDueDateFrom: Date | null;
    reportDueDateTo: Date | null;
    reportStatus: string;
}

export type AuthorizationListAction =
    | { type: 'SET_SELECTED'; selected: AuthorizationInfo | null }
    | { type: 'SET_SORT_BY'; sortBy: AuthorizationSortBy }
    | { type: 'SET_SEARCH'; search: string }
    | { type: 'SET_FILTER'; filter: AuthorizationListFilterValue }
    | { type: 'SET_PAGE_SIZE'; pageSize: number }
    | RelayPaginationActionPayload;


export interface AuthorizationListState {
    pagination: RelayPaginationState;
    sortBy: AuthorizationSortBy;
    filter: AuthorizationListFilterValue;
    selected: AuthorizationInfo | null;
    search: string;
    pageSize: number;
}

export function initState(): AuthorizationListState {
    const currentDate: Date = new Date();
    const defaultPagination = new RelayPaginationState('0', DEFAULT_PAGE_SIZE);
    return {
        pagination: defaultPagination,
        pageSize: defaultPagination.size,
        selected: null,
        search: "",
        filter: {
            authType: "",
            serviceType: "",
            status: "",
            reportStatus: "",
            reportSubmittedDateFrom: null,
            reportSubmittedDateTo: null,
            reportDueDateTo: add(currentDate, {days: 45}),
            reportDueDateFrom: add(currentDate, {days: -15})
        },
        sortBy: {
            column: "reportDueDate",
            order: SortOrder.ASC,
        },
    };
}

export function authorizationListReducer(
    state: AuthorizationListState,
    action: AuthorizationListAction
): AuthorizationListState {
    switch (action.type) {
        case 'SET_SELECTED':
            return {
                ...state,
                selected: action.selected
            }
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy
            };
        case 'SET_SEARCH':
            return {
                ...state,
                search: action.search,
                pagination: new RelayPaginationState('0', state.pageSize),
            };
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
                pagination: new RelayPaginationState('0', state.pageSize),
            }
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
                pagination: new RelayPaginationState('0', action.pageSize),
            };
        default:
            return state;
    }
}
